/**
 * @fileOverview The Consumer analytics framework. See {@link ./README.md} for details.
 */

export * from './monitors';
export { tracker } from './trackers';
export { Analytics } from './Analytics';
export * from './events';
